import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/img/logo.png';


export const Footer = () => {
  const { t } = useTranslation();
    return(
        <footer className="w-full bg-darkGray py-6 flex flex-col items-center justify-center z-50 shrink-0">
            <div className="mb-3">
                <img src={logo} alt="Slash Mobility" className="h-5 w-auto brightness-0 invert opacity-80" />
            </div>
            <div className="flex gap-6">
                <span className="text-secondary text-xs cursor-pointer hover:text-white transition-colors">{t('LOGIN.LEGAL_NOTICE')}</span>
                <span className="text-secondary text-xs cursor-pointer hover:text-white transition-colors">{t('LOGIN.PRIVACY_POLICY')}</span>
            </div>
        </footer>
    );
}